import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="border-t border-[#1A1A1A] bg-[#050505]">
      <div className="max-w-[1400px] mx-auto w-full px-6 md:px-12 lg:px-24 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          {/* Brand */}
          <div className="md:col-span-5">
            <img src="/mist-logo.png" alt="Mist Media" className="h-7 w-auto" />
            <p className="mt-5 text-sm text-[#52525B] leading-relaxed max-w-sm">
              A future-forward production company creating bold stories across film, television, and digital platforms.
            </p>
          </div>

          {/* Navigation */}
          <div className="md:col-span-3">
            <h4 className="text-[10px] uppercase tracking-[0.3em] font-bold text-[#3f3f46] mb-5">Navigate</h4>
            <div className="flex flex-col gap-3">
              {[
                { name: "Home", path: "/" },
                { name: "Projects", path: "/projects" },
                { name: "Thoughts", path: "/thoughts" },
                { name: "About", path: "/about" },
                { name: "Contact", path: "/contact" },
              ].map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-sm text-[#52525B] hover:text-white transition-colors duration-300 inline-flex items-center gap-1 group"
                >
                  {link.name}
                  <ArrowUpRight size={10} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <h4 className="text-[10px] uppercase tracking-[0.3em] font-bold text-[#3f3f46] mb-5">Get in Touch</h4>
            <a href="mailto:hello@mistmedia.com" className="text-sm text-[#52525B] hover:text-white transition-colors block mb-2">
              hello@mistmedia.com
            </a>
            <p className="text-sm text-[#3f3f46]">Los Angeles, CA</p>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-[#141414] flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[10px] text-[#3f3f46] tracking-wider uppercase">
            &copy; {new Date().getFullYear()} Mist Media. All rights reserved.
          </p>
          <Link to="/admin" data-testid="admin-footer-link" className="text-[10px] text-[#27272A] hover:text-[#52525B] transition-colors tracking-wider uppercase">
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
}
